/* ------------------------------------------------------------
   Editorial tables — progressive enhancement
   ------------------------------------------------------------
   Finds every plain <table> inside rich text (.rte) and copies each
   column's heading onto its body cells as `data-label`. CSS then uses
   `content: attr(data-label)` to stack the table into labelled cards
   on mobile (see ak-article-table.css).

   Why JS: a table cannot show its column headings once the rows are
   stacked — CSS alone cannot pull <th> text into a <td>. Doing it here
   means authors keep pasting an ordinary table into the Shopify editor
   and never touch markup or CSS.

   Fails safe: if this never runs, the table simply keeps its default
   styling and scrolls horizontally on mobile. Nothing breaks.
   ------------------------------------------------------------ */
(function () {
  function enhanceTables(root) {
    var tables = (root || document).querySelectorAll('.rte table');

    Array.prototype.forEach.call(tables, function (table) {
      if (table.classList.contains('ak-table--stacked')) return;

      // Column headings drive the mobile labels. No <thead>, no stacking —
      // fall back to horizontal scroll rather than stack unlabelled cells.
      var heads = table.querySelectorAll('thead th');
      if (!heads.length) return;

      var labels = Array.prototype.map.call(heads, function (th) {
        return th.textContent.trim();
      });

      var rows = table.querySelectorAll('tbody tr');
      Array.prototype.forEach.call(rows, function (row) {
        Array.prototype.forEach.call(row.children, function (cell, i) {
          // Don't clobber a label an author set deliberately.
          if (labels[i] && !cell.hasAttribute('data-label')) {
            cell.setAttribute('data-label', labels[i]);
          }
        });
      });

      table.classList.add('ak-table--stacked');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceTables();
    });
  } else {
    enhanceTables();
  }
})();
